'use client';

import { ReactNode, useEffect, useRef } from 'react';
import { Provider } from 'react-redux';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { PersistGate } from 'redux-persist/integration/react';

import { ChakraProvider } from '@chakra-ui/react';

import { AppStore, makeStore, persist } from 'store';

import theme from 'styles/theme';

import { CustomScrollBar } from 'components';
import { Loader } from 'ui';

const Providers = ({ children }: { children: ReactNode }) => {
  const storeRef = useRef<AppStore>();

  if (!storeRef.current) {
    storeRef.current = makeStore();
  }

  useEffect(() => {
    window.addEventListener('error', (e) => {
      console.error('Global error:', e.error);
    });
    window.addEventListener('unhandledrejection', (e) => {
      console.error('Unhandled promise rejection:', e.reason);
    });
  }, []);

  useEffect(() => {
    const fetchIp = async () => {
      const res = await fetch('https://api4.ipify.org?format=json');
      const data = await res.json();

      localStorage.setItem('client_ip', data.ip);
    };

    fetchIp();
  }, []);

  return (
    <NuqsAdapter>
      <CustomScrollBar maxHeight='100vh'>
        <Provider store={storeRef.current}>
          <ChakraProvider theme={theme}>
            <PersistGate loading={<Loader fixed />} persistor={persist}>
              {children}
            </PersistGate>
          </ChakraProvider>
        </Provider>
      </CustomScrollBar>
    </NuqsAdapter>
  );
};

export default Providers;
